module.exports = __webpack_public_path__ + "img/last-show_icon.4aad38ba.webp";